var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgOverdue = function SvgOverdue(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "overdue_svg__Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".overdue_svg__overdue1{stroke:#000;stroke-width:.5;stroke-miterlimit:10}")), /*#__PURE__*/React.createElement("path", {
    d: "M500 1000C224.3 1000 0 775.7 0 500S224.3 0 500 0s500 224.3 500 500-224.3 500-500 500zm0-926.8C264.6 73.2 73.2 264.6 73.2 500S264.6 926.8 500 926.8 926.8 735.4 926.8 500 735.4 73.2 500 73.2z",
    style: {
      stroke: "#000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 597.6c-20.2 0-36.6-16.4-36.6-36.6V280.5c0-20.2 16.4-36.6 36.6-36.6s36.6 16.4 36.6 36.6V561c0 20.2-16.4 36.6-36.6 36.6zM500 756.1c-20.2 0-36.6-16.4-36.6-36.6s16.4-37.3 36.6-37.3 36.6 15.6 36.6 35.8v1.5c0 20.2-16.4 36.6-36.6 36.6z",
    className: "overdue_svg__overdue1"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOverdue);
export default ForwardRef;